// extracted by mini-css-extract-plugin
export default {"root":"BlogCard_root__-aeL6","title":"BlogCard_title__unY0F","category":"BlogCard_category__nhfs7","author":"BlogCard_author__dHs6H","chip":"BlogCard_chip__NxTIO"};